import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Commons } from '../../../../shared/Commons';
import { CustomersService } from '../../../../services/customers.service';
import { TranslocoModule } from '@ngneat/transloco';
import { RouterModule } from '@angular/router';
import { DatePipe, NgIf } from '@angular/common';
import { CookieConsentService } from '../../../../services/cookie-consent.service';

@Component({
  selector: 'app-admin-footer',
  standalone: true,
  imports: [
    RouterModule,
    TranslocoModule,
    DatePipe,
    NgIf
  ],
  templateUrl: './admin-footer.component.html',
  styleUrl: './admin-footer.component.scss'
})
export class AdminFooterComponent implements OnInit {

  version = environment.appVersion
  appName = environment.appName
  footerInfo = environment.footerInfo
  officeLocation = environment.officeLocation
  contactEmail = environment.contactEmail
  contactPhone = environment.contactPhone
  orgName = environment.orgName
  providerWeb = environment.providerWeb
  ABOUT_US: string = this.providerWeb + '/about'
  CONTACT_US: string = this.providerWeb + '/contact'
  getScreenWidth: any;
  mobileWidth: number = Commons.MOBILE_WIDTH

  anio: Date = new Date();

  constructor(
    private customersService: CustomersService,
    private cookieConsentService: CookieConsentService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.getScreenWidth = this.isBrowser ? window.innerWidth : Commons.MOBILE_WIDTH + 1
  }

  get isBrowser() {
    return Commons.isBrowser(this.platformId);
  }

  toSupport() {
    this.openNewWindow(Commons.PATH_SUPPORT)
  }

  toStore() {
    this.openNewWindow('store')
  }

  toPP() {
    this.openNewWindow(Commons.PATH_TERMS + '/privacy-policy')
  }

  toTC() {
    this.openNewWindow(Commons.PATH_TERMS + '/terms-conditions')
  }

  toST() {
    this.openNewWindow(Commons.PATH_TERMS + '/terms-sales')
  }

  toCP() {
    this.openNewWindow(Commons.PATH_TERMS + '/cookie-policy')
  }

  openNewWindow(path: string) {
    this.customersService.createTransientAuth().subscribe({
      next: (v) => {
        Commons.openWithExternalToken(this.platformId, path, v.transient_auth)
      },
      error: (e) => {
      },
      complete: () => { }
    })

  }

  openNewWindowWhithoutToken(path: string) {
    Commons.openWithoutExternalToken(this.platformId, path)
  }

  get isMobile() {
    return this.getScreenWidth < this.mobileWidth
  }

  get showCookiePreferences(): boolean {
    return this.cookieConsentService.hasTrackingConfigured()
  }

  onClickCookiePreferences(): void {
    this.cookieConsentService.requestReopen()
  }

}
